<template>
    <drawer title="Select Template" class="flex-template-drawer">
        <template v-slot:header-secondary>
            <drawer-tabs
                :tabs="drawerNavTabs"
                :active-tab="activeNavTab"
                @selected="setActiveTab"
            />
        </template>

        <template-browser
            v-if="!pageBaseSelected"
            :template-mode="true"
            @selected="selected"
            @create-new="createNew"
        />

        <div v-else class="page-data__container">
            <div v-if="isSaving">
                <loading-component />
            </div>

            <template v-else>
                <button class="page-data__back" @click="backToSelect">
                    <font-awesome-icon :icon="['fal', 'arrow-left']" /> Back
                </button>

                <page-data @save="createTemplate" @cancel="onCancel" />
            </template>
        </div>
    </drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import LoadingComponent from '@/components/shared/loading/loading-component';
import Drawer from '@/components/shared/drawer/drawer';
import DrawerTabs from '@/components/shared/drawer/tabs';
import PageData from '@/components/page-editor/shared/page-data';
import * as service from '@/sitecore/sitecore-data-service';
import { SHOW_ALERT, HIDE_DRAWER } from '@/store/types/mutation-types';

export default {
    name: 'load-template',

    components: {
        Drawer,
        LoadingComponent,
        PageData,
        DrawerTabs,
    },

    data() {
        return {
            isSaving: false,
            showNav: true,
            drawerNavTabs: ['Templates'],
            activeNavTab: 'Templates',
            pageBaseSelected: false,
            pageBase: {},
        };
    },

    computed: {
        ...mapState({
            newPagePath: ({ page }) => page.newPagePath,
        }),
    },

    methods: {
        ...mapMutations({
            hideDrawer: HIDE_DRAWER,
            showAlert: SHOW_ALERT,
        }),

        createNew() {
            this.pageBaseSelected = true;
            this.showNav = false;
        },

        async createTemplate(pageData) {
            this.isSaving = true;
            const fullPageData = pageData;
            fullPageData.path = this.newPagePath;
            const response = await service.createTemplate(fullPageData);
            if (response.status === 'error') {
                this.isSaving = false;
                this.showAlert({ description: response.error });
                return;
            }
            window.location.href = `/templates/${ response.data }`;
        },

        setActiveTab(tab) {
            this.activeNavTab = tab;
        },

        selected(pageBase) {
            window.location.href = `/templates/${ pageBase.standardValueItem }`;
        },

        backToSelect() {
            this.pageBaseSelected = false;
            this.showNav = true;
        },

        onCancel() {
            this.hideDrawer();
        },
    },
};
</script>

<style lang="scss">
.flex-template-drawer {
    overflow-y: auto;

    .page-data {
        &__container {
            min-width: 100%;
            height: calc(100vh - #{ $drawer-header-height } - 50px); // 50px = height of buttons on bottom
            overflow-y: auto;
        }

        &__back {
            margin: 25px 35px 0 35px;
            color: var(--form-buttonBackgroundColor);
        }
    }
}
</style>
